<div class="annotation-layout">
<div class="table-actions-container">
  <div class="events-group">
  <span class="controls-label">Events:</span>
  <div class="menu-wrapper">
  <button type="button" class="pill-button" aria-haspopup="true" [attr.aria-expanded]="showActionMenu"
    (click)="toggleActionMenu()" title="Add an annotation event">
    <i class="material-icons">add</i>
    <span>Annotation</span>
  </button>
  <div class="actions-menu" *ngIf="showActionMenu">
    <button type="button" class="actions-menu-item" (click)="selectAction('Annotation')">📝 Annotation (Ctrl +
      Q)</button>

    <button type="button" class="actions-menu-item" *ngIf="!decisionActive" (click)="selectAction('Start Decision')">⚖️
      Start Decision (Ctrl + E)</button>
    <button type="button" class="actions-menu-item" *ngIf="decisionActive" (click)="selectAction('Stop Decision')">⚖️
      Stop Decision (Ctrl + E)</button>

    <button type="button" class="actions-menu-item" *ngIf="!dispositionActive" (click)="selectAction('Disposition')">🟢
      Disposition (Ctrl + Y)</button>

    <button type="button" class="actions-menu-item" (click)="selectAction('Time Stamp')">⏱️ Time Stamp (Ctrl +
      M)</button>

    <button type="button" class="actions-menu-item" *ngIf="!sidebarActive" (click)="selectAction('Start Sidebar')">⚡
      Start Sidebar (Ctrl + U)</button>
    <button type="button" class="actions-menu-item" *ngIf="sidebarActive" (click)="selectAction('Stop Sidebar')">⚡ Stop
      Sidebar (Ctrl + U)</button>
  </div>
  </div>
  <div class="menu-wrapper speakers-wrapper">
    <button type="button" class="pill-button" aria-haspopup="true" [attr.aria-expanded]="showSpeakerMenu"
      [disabled]="!speakerShortcuts.length" (click)="toggleSpeakerMenu()"
      [title]="speakerShortcuts.length ? 'Add a speaker annotation' : 'No speakers in the selected case form'">
      <i class="material-icons">record_voice_over</i>
      <span>Speakers</span>
    </button>
    <div class="actions-menu speakers-menu" *ngIf="showSpeakerMenu">
      <button type="button" class="actions-menu-item" *ngFor="let item of speakerShortcuts"
        [title]="item.speaker.label" (click)="selectSpeaker(item.speaker)">👤 {{ item.speaker.name }} - {{ item.speaker.label }}<ng-container
          *ngIf="item.letter || item.digit"> (Ctrl + Shift + {{ item.letter || item.digit }})</ng-container></button>
    </div>
  </div>
  </div>
  <div class="actions-extra">
    <button type="button" class="actions-icon-button" title="Refresh" (click)="refreshAnnotations()">
      <i class="material-icons">refresh</i>
    </button>
    <button *ngIf ="showMaximizeButton" type="button" class="actions-icon-button" [title]="isMaximized ? 'Minimize' : 'Maximize'"
      (click)="toggleMaximizeView()">
      <i class="material-icons">{{ isMaximized ? 'fullscreen_exit' : 'fullscreen' }}</i>
    </button>
  </div>
</div>
<div class="controls-card" *ngIf="isOpenedByAudioStreamingList">
  <span class="controls-label">Time Source:</span>
  <div id="timeSourcePlayer" class="timestamp-btn selected" data-value="player" (click)="selectTimeSource('Player')">
    <div class="btn-icon">
      <span class="currency-symbol">▶️</span>
    </div>
    <span class="btn-text">Player Time</span>
  </div>
  <!-- <div id="timeSourceManual" class="timestamp-btn" data-value="manual" (click)="selectTimeSource('Manual')">
    <div class="btn-icon">
      <span class="currency-symbol">✏️</span>
    </div>
    <span class="btn-text">Manual Time</span>
  </div> -->
</div>
<div #annotationTableContainer class="table-container">
  <table id="annotationTable">
    <thead>
      <tr>
        <th style="width: 10%;">
          <div class="header-container">Time<div class="resizer"></div>
          </div>
        </th>
        <th style="width: 30%;">
          <div class="header-container">Speaker<div class="resizer"></div>
          </div>
        </th>
        <th style="width: 45%;">
          <div class="header-container">Comments<div class="resizer"></div>
          </div>
        </th>
        <th *ngIf = "!isDisabled" style="width: 5%;text-align: center; border-right: none;" title="Actions" aria-label="Actions">
          <div class="header-container"><i class="material-icons">delete</i></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of annotationsList" [attr.data-annotation-id]="row.id" (click)="onRowClick(row)">
        <!-- <td><span class="text-wrapper" title="{{ row.timeStamp }}">{{ row.timeStamp }}</span></td> -->
        <td>
          <span class="text-wrapper" title="{{ row.timeStamp }}">
            <ng-container *ngIf="selectedTimeStamp === 'Manual' && row.isNewManualRow; else readOnlyTime">
              <input #timeStampInput type="text" [(ngModel)]="row.timeStamp" [class.invalid-input]="row.isTimeInvalid"
                (input)="onTimeInput($event, row)" class="comment-input" placeholder="HH:mm:ss" maxlength="8"
                (keydown)="onTimeStampInputKeyDown($event, row)" (blur)="onTimeStampInputBlur(row)"
                [attr.autofocus]="true" />
            </ng-container>

            <ng-template #readOnlyTime>
              {{ row.timeStamp }}
            </ng-template>
          </span>
        </td>
        <td><span class="text-wrapper" title="{{ row.speaker }}">{{ row.speaker }}</span></td>
        <td (dblclick)="startRowEdit(row)"><span class="text-wrapper" title="{{ row.comments }}">
            <ng-container *ngIf="row.isEditing && !isSystemInitRow(row); else viewComment">
              <input #commentInput type="text" class="comment-input" [(ngModel)]="row.comments"
                (keydown)="onCommentInputKeyDown($event, row)" (blur)="saveRow(row)" [attr.autofocus]="true"
                placeholder="Enter comments" />
            </ng-container>
            <ng-template #viewComment>
              {{ row.comments }}
            </ng-template>
          </span>
        </td>
        <td *ngIf = "!isDisabled"  style="text-align: center;">
          <button *ngIf = "!row.speaker?.toLowerCase()?.includes('system')"
           (click)="confirmDelete(row.id)" class="btn-delete-icon" type="button" title="Delete row">
            <i class="material-icons">delete_outline</i>
          </button>
        </td>
      </tr>

      <tr *ngIf="annotationsList.length === 0">
        <td colspan="4" style="text-align: center; color: #888;">No annotations found.</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="delete-confirm-overlay" *ngIf="deleteConfirmationId !== null">
  <div class="delete-confirm-card">
    <div class="delete-confirm-title">Confirm delete</div>
    <div class="delete-confirm-message">Are you sure? Do you want to delete?</div>
    <div class="delete-confirm-actions">
      <button type="button" class="delete-btn cancel" (click)="cancelDelete()">No</button>
      <button type="button" class="delete-btn confirm" (click)="deleteRow(deleteConfirmationId!)">Yes</button>
    </div>
  </div>
</div>
</div>